import React, { useEffect, useMemo, useRef, useState } from "react";
import { Modal } from "@material-ui/core";
import styled from "styled-components";
import { Card } from "@shopify/polaris";

const ModalBody = styled.div`
  width: 105rem;
  max-width: 95vw;
  height: 80vh;
  max-height: 95vh;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
`;

const PreviewFrame = styled.iframe`
  width: 100%;
  height: 70vh;
  border: 0;
`;

export default function ParcelLabelModal({
  open,
  onClose,
  pdfUrl,
  filename,
  loading,
}) {
  const iframeRef = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(false);
  }, [pdfUrl, open]);

  const secondaryFooterActions = useMemo(() => {
    return [
      {
        content: "Open PDF",
        onAction: () => {
          if (!pdfUrl) return;
          window.open(pdfUrl, "_blank");
        },
        disabled: !pdfUrl,
      },
    ];
  }, [pdfUrl]);

  const primaryFooterAction = useMemo(() => {
    return {
      content: "Print",
      onAction: () => {
        try {
          const frameWindow = iframeRef.current?.contentWindow;
          if (frameWindow) {
            frameWindow.focus();
            frameWindow.print();
            return;
          }
        } catch (e) {
          // fall back to opening the PDF
        }

        if (pdfUrl) {
          const w = window.open(pdfUrl, "_blank");
          if (w) w.focus();
        }
      },
      disabled: !pdfUrl || !ready,
    };
  }, [pdfUrl, ready]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="parcel-label-modal"
      aria-describedby="parcel-label-preview"
    >
      <ModalBody>
        <Card
          sectioned
          title={filename || "Parcel Label"}
          secondaryFooterActions={secondaryFooterActions}
          primaryFooterAction={primaryFooterAction}
        >
          {loading ? (
            "Loading..."
          ) : pdfUrl ? (
            <PreviewFrame
              ref={iframeRef}
              title="Parcel Label Preview"
              src={pdfUrl}
              onLoad={() => setReady(true)}
            />
          ) : (
            "No label available."
          )}
        </Card>
      </ModalBody>
    </Modal>
  );
}
